//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data: function data() {
    return {
      text: null,
      visible: false,
      fontSize: 12
    };
  },

  watch: {
    visible: function visible(params) {
      var _this = this;

      this.$nextTick(function () {
        if (_this.$el.getBoundingClientRect().height > 0) {
          var fontSize = _this.$el.getBoundingClientRect().height * 0.38;
          if (fontSize > 40) {
            fontSize = 40;
          }
          _this.fontSize = fontSize;
        } else {
          _this.fontSize = 12;
        }
      });
    }
  },
  computed: {},
  mounted: function mounted() {},

  methods: {
    setText: function setText(text) {
      if (text) {
        this.text = text;
      }
    },
    setIcon: function setIcon(icon) {
      this.icon = icon;
    }
  }
};